var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMesCommandes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88666 0.334961C7.119 0.334961 5.42373 1.03716 4.1738 2.28709C2.92387 3.53702 2.22167 5.23229 2.22167 6.99996H0L2.88076 9.88072L2.9326 9.9844L5.92444 6.99996H3.70278C3.70278 4.13401 6.02071 1.81607 8.88666 1.81607C11.7526 1.81607 14.0705 4.13401 14.0705 6.99996C14.0705 9.86591 11.7526 12.1838 8.88666 12.1838C7.45739 12.1838 6.16142 11.5988 5.22832 10.6583L4.17673 11.7099C4.79392 12.3305 5.52787 12.8228 6.33624 13.1583C7.14461 13.4939 8.01141 13.666 8.88666 13.665C10.6543 13.665 12.3496 12.9628 13.5995 11.7128C14.8495 10.4629 15.5517 8.76762 15.5517 6.99996C15.5517 5.23229 14.8495 3.53702 13.5995 2.28709C12.3496 1.03716 10.6543 0.334961 8.88666 0.334961ZM8.14611 4.03774V7.74051L11.2935 9.60671L11.8637 8.6514L9.25694 7.10364V4.03774H8.14611Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesCommandes);
export default __webpack_public_path__ + "static/media/mes-commandes.f8110d302495604ee5fad8e9293bd986.svg";
export { ForwardRef as ReactComponent };